import { getTranscriptions } from '../api/CCSmartsAudioAPI';
import { createBase64FromBlob } from '../api/createBase64';

import { createWAVFromAudioBuffer } from './createWAVFromAudioBuffer';
import { getLastRecorderAudioChunk } from './getLastRecorderAudioChunk';

export const processAudioToText = async (audioChunks: Blob[], lastProcessedPosition: number) => {
	const completeAudio = new Blob(audioChunks);

	const { wavBlob, newAudioEndPosition } = await getLastRecorderAudioChunk(
		completeAudio,
		lastProcessedPosition,
		createWAVFromAudioBuffer,
	);

	const audioString = await createBase64FromBlob(wavBlob);
	const transcription = await getTranscriptions({ audioString });

	return { transcription: transcription[0], newAudioEndPosition };
};
